/**
 * Quackback owns changelog (and optional messenger/tickets) unread.
 * Ofertator only mirrors the SDK `unread` event — never invents a second seen store.
 */

export type QuackbackUnreadPayload = {
  count?: number
}

export type QuackbackCommand = ((...args: unknown[]) => unknown) & { q?: unknown[] }

export function normalizeUnreadCount(payload: unknown): number {
  if (!payload || typeof payload !== 'object') return 0
  const count = (payload as QuackbackUnreadPayload).count
  if (typeof count !== 'number' || !Number.isFinite(count)) return 0
  return Math.max(0, Math.floor(count))
}

/**
 * Subscribe to widget aggregate unread. Returns unsubscribe, or null if the
 * SDK stub is still queued (caller should retry after load).
 */
export function subscribeQuackbackUnread(
  qb: QuackbackCommand | undefined,
  onCount: (count: number) => void,
): (() => void) | null {
  if (typeof qb !== 'function' || qb.q) return null

  const handler = (payload: unknown) => {
    onCount(normalizeUnreadCount(payload))
  }

  const unsub = qb('on', 'unread', handler)
  if (typeof unsub === 'function') {
    return () => {
      ;(unsub as () => void)()
    }
  }

  return () => {
    qb('off', 'unread', handler)
  }
}
